import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { grey } from "@mui/material/colors";
import { alpha } from "@mui/material/styles";

/**
 * CheckboxRow — the bordered, tint-on-check row used by every "check all that
 * apply" list. Presentational only: no react-final-form wiring.
 *
 * Shared by RffBooleanCheckbox (`boxed`, one boolean field per row) and
 * RffCheckboxArrayField (one array field, one row per option) so the two read
 * as the same control wherever they sit next to each other. They look identical
 * because they ARE the same markup — don't restyle one in isolation.
 *
 * `radio` swaps the checkbox glyph for a radio so a "pick exactly one" list
 * (e.g. the subject-property picker on the appraisal-order form) reads as
 * single-select while keeping the same row chrome. The caller still owns the
 * exclusivity — `onChange(true)` fires when the row is clicked.
 */
const CheckboxRow = ({ checked, onChange, label, disabled, sx, radio }) => (
  <FormControlLabel
    sx={(theme) => ({
      m: 0,
      width: "100%",
      alignItems: "flex-start",
      gap: 1.25,
      px: 1.75,
      py: 1.25,
      borderRadius: "8px",
      border: "1px solid",
      borderColor: checked ? theme.palette.primary.main : grey[300],
      backgroundColor: checked
        ? alpha(theme.palette.primary.main, 0.05)
        : "#ffffff",
      transition: "border-color .15s, background-color .15s",
      "&:hover": {
        borderColor: checked ? theme.palette.primary.main : grey[400],
      },
      "& .MuiFormControlLabel-label": {
        fontSize: "13px",
        lineHeight: 1.45,
        color: grey[800],
        pt: "1px",
      },
      ...sx,
    })}
    control={
      radio ? (
        <Radio
          size="small"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          sx={{ p: 0, mt: "1px" }}
        />
      ) : (
        <Checkbox
          size="small"
          checked={checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
          sx={{ p: 0, mt: "1px" }}
        />
      )
    }
    label={label}
  />
);

export default CheckboxRow;
